import React from 'react';
import PropTypes from 'prop-types';
// import Paper from '@material-ui/core/Paper';
import CardContent from '@mui/material/CardContent';
import FieldCheckbox from '../../../../molecules/opportunity-wizard/FieldCheckbox';
import Typography from '../../../../atoms/Typography';
import SectionSkeleton from './skeleton';
import { Paper } from './style';

const GeneralFields = ({ key, section, formFields, setFormFields }) => {
  return (
    <Paper variant="outlined" key={key}>
      <CardContent>

        <Typography variant="h5">{section.name}</Typography>
        {section.fields.length > 0 &&
          section.fields.map(field => {
            const checked = field.is_required || formFields.fields.includes(field.id);
            if (field.is_required && !formFields.fields.includes(field.id)) {
              const newFormFields = { ...formFields };
              newFormFields.fields = [...formFields.fields, field.id];
              setFormFields(newFormFields);
            }
            let fieldView = null;

            fieldView = (
              <FieldCheckbox
                checked={checked}
                onClick={() => {
                  if (!field.is_required) {
                    if (checked) {
                      const newFormFields = { ...formFields };
                      newFormFields.fields.splice(formFields.fields.indexOf(field.id), 1);
                      setFormFields(newFormFields);
                    } else {
                      const newFormFields = { ...formFields };
                      newFormFields.fields = [...formFields.fields, field.id];
                      setFormFields(newFormFields);
                    }
                  }
                }}
              >
                {field.name}
              </FieldCheckbox>
            );

            return fieldView;
          })}
      </CardContent>
    </Paper>
  );
};

GeneralFields.propTypes = {
  section: PropTypes.objectOf({
    name: PropTypes.string,
    slug: PropTypes.string,
    fields: PropTypes.arrayOf({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  }).isRequired,
  formFields: PropTypes.objectOf({
    terms: PropTypes.string,
    fields: PropTypes.arrayOf(PropTypes.string),
    attachments: PropTypes.arrayOf(PropTypes.string),
    is_active: PropTypes.bool,
    custom_fields: PropTypes.arrayOf({
      name: PropTypes.string,
      type: PropTypes.string,
      choicecs: PropTypes.arrayOf(PropTypes.string),
    }),
  }).isRequired,
  setFormFields: PropTypes.func.isRequired,
  key: PropTypes.string
};

GeneralFields.defaultProps = {
  key: undefined
}

GeneralFields.Skeleton = SectionSkeleton;

export default GeneralFields;
